import { render, staticRenderFns } from "./GetRead.vue?vue&type=template&id=480a95fc"
import script from "./GetRead.vue?vue&type=script&lang=js"
export * from "./GetRead.vue?vue&type=script&lang=js"
import style0 from "./GetRead.vue?vue&type=style&index=0&id=480a95fc&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports